// components/Loader.js
import React from "react";
import Spinner from 'react-bootstrap/Spinner';

const Loader = () => {
  return (
    <Spinner animation="border" />
  );
};

export default Loader;
